import { View, Text } from "@react-pdf/renderer";
import { commonRelatorioPdfStyles } from "../styles";
import PDFTable from "ui/components/PDF/Table";
import useResumoPorCategoriaColumns from "./hooks/useResumoPorCategoriaColumns";
import TotalRow from "./TotalRow";
import { ResumoCategoriaItem } from "core/features/relatorios/conta-com-composicoes/typings";

interface ResumoPorCategoriaProps<
  T extends { resumoPorCategoria: ResumoCategoriaItem[] }
> {
  data: T & { valorTotal?: number };
  title?: string;
}

export default function ResumoPorCategoria<
  T extends { resumoPorCategoria: ResumoCategoriaItem[] }
>({ data, title = "Resumo por categoria" }: ResumoPorCategoriaProps<T>) {
  const columns = useResumoPorCategoriaColumns();
  return (
    <View>
      <View style={commonRelatorioPdfStyles.itemTableTitleRow}>
        <Text style={commonRelatorioPdfStyles.itemTableTitle}>{title}</Text>
      </View>
      <PDFTable
        data={data.resumoPorCategoria}
        columns={columns}
        tableHeaderVariant="rowLike"
      />
      {data?.valorTotal ? (
        <View style={commonRelatorioPdfStyles.itemTableSummary}>
          <TotalRow title="Total" valorTotal={data?.valorTotal!} />
        </View>
      ) : null}
    </View>
  );
}
